module.exports = __webpack_public_path__ + "img/1531452329.5c59f12c.jpg";